var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationPin3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 348,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C114.84 0 229.68 0 348 0 C348 168.96 348 337.92 348 512 C233.16 512 118.32 512 0 512 C0 343.04 0 174.08 0 0 Z ",
    fill: "#CE2327",
    transform: "translate(0,0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C52.47 0 104.94 0 159 0 C159 0.33 159 0.66 159 1 C158.23147705 1.11480713 157.4629541 1.22961426 156.67114258 1.34790039 C130.87229895 5.28279592 105.29366278 11.14634181 83.5 26.375 C81 28 81 28 78 28 C78 28.66 78 29.32 78 30 C77.01 30 76.02 30 75 30 C75 30.66 75 31.32 75 32 C73.23696322 33.43787433 71.41174153 34.79982567 69.5625 36.125 C64.67470452 39.67057748 60.14909154 43.42585356 55.7421875 47.56640625 C54 49 54 49 52 49 C52 49.66 52 50.32 52 51 C51.34 51 50.68 51 50 51 C49.72599365 51.59240479 49.4519873 52.18480957 49.16967773 52.79516602 C48.0440618 54.91694382 46.87248678 56.48676572 45.28515625 58.27734375 C44.76373047 58.87353516 44.24230469 59.46972656 43.70507812 60.08398438 C42.89200195 61.00147461 42.89200195 61.00147461 42.0625 61.9375 C37.83156452 66.69652833 37.83156452 66.69652833 34.24609375 71.94140625 C33.62927734 72.96041016 33.62927734 72.96041016 33 74 C32.34 74 31.68 74 31 74 C30.72414063 74.73605469 30.44828125 75.47210938 30.1640625 76.23046875 C29.08339456 78.8015881 27.86790844 80.96471382 26.375 83.3125 C15.57739235 101.12461189 8.04168357 120.06945107 4.42553711 140.60375977 C4.12828371 142.27762217 3.80679122 143.94728061 3.46704102 145.61303711 C1.74041059 154.63280597 1.55784352 163.5350631 1.5625 172.6875 C1.56209717 173.50191559 1.56169434 174.31633118 1.5612793 175.15542603 C1.60223802 189.59602254 3.12883623 203.0412555 7 217 C7.41813965 218.53744873 7.41813965 218.53744873 7.84472656 220.10595703 C15.522424 247.78562923 26.45808499 274.20482677 39 300 C39.57153809 301.18013672 40.14307617 302.36027344 40.73193359 303.57617188 C49.48483501 321.57571558 58.85115328 339.15893039 69.1875 356.30078125 C71.22148853 359.67619581 73.16539292 363.07347047 75 366.5625 C77.32117571 370.87065074 79.87051355 374.91701979 82.6328125 378.953125 C83.84509667 380.76808759 84.94145857 382.59287577 86 384.5 C87.9879749 388.07835483 90.27459847 391.42727405 92.56640625 394.81640625 C94.12319802 397.18765039 95.49590392 399.64114891 96.87109375 402.12109375 C98.8443584 405.40531623 101.12803362 408.47704515 103.34765625 411.59765625 C105.00691934 414.01006004 106.42992875 416.50061738 107.82421875 419.07421875 C110.07029307 422.75300492 112.77316157 426.12697752 115.390625 429.546875 C117 432 117 432 117 435 C117.66 435 118.32 435 119 435 C119 435.99 119 436.98 119 438 C119.66 438 120.32 438 121 438 C121 438.99 121 439.98 121 441 C121.66 441 122.32 441 123 441 C124.2890625 442.42578125 124.2890625 442.42578125 125.625 444.3125 C126.29402344 445.23482422 126.29402344 445.23482422 126.9765625 446.17578125 C128 448 128 448 128 451 C128.66 451 129.32 451 130 451 C131.2890625 452.42578125 131.2890625 452.42578125 132.625 454.3125 C133.29402344 455.23482422 133.29402344 455.23482422 133.9765625 456.17578125 C135 458 135 458 135 461 C135.66 461 136.32 461 137 461 C137.33 462.32 137.66 463.64 138 465 C138.66 465 139.32 465 140 465 C141.23681641 466.43701172 141.23681641 466.43701172 142.6015625 468.4296875 C143.09140625 469.14253906 143.58125 469.85539062 144.0859375 470.58984375 C144.59382812 471.34394531 145.10171875 472.09804688 145.625 472.875 C146.140625 473.62136719 146.65625 474.36773437 147.1875 475.13671875 C151 480.734437 151 480.734437 151 483 C151.66 483 152.32 483 153 483 C153.33 484.32 153.66 485.64 154 487 C154.66 487 155.32 487 156 487 C156.33 488.32 156.66 489.64 157 491 C157.66 491 158.32 491 159 491 C160.7265625 493.1171875 160.7265625 493.1171875 162.625 495.875 C163.25664062 496.77992188 163.88828125 497.68484375 164.5390625 498.6171875 C166 501 166 501 166 503 C166.66 503 167.32 503 168 503 C169.39138161 504.74814612 170.56294846 506.59672568 171.78125 508.46875 C172.38453125 509.22671875 172.38453125 509.22671875 173 510 C173.66 510 174.32 510 175 510 C176.28463521 508.43581846 176.28463521 508.43581846 177.5 506.5 C178.78125 504.53125 178.78125 504.53125 180 503 C180.66 503 181.32 503 182 503 C182.33 501.68 182.66 500.36 183 499 C183.66 499 184.32 499 185 499 C185.226875 498.319375 185.45375 497.63875 185.6875 496.9375 C187.31226146 493.3011291 189.32803257 489.97170737 192 487 C192.66 487 193.32 487 194 487 C194.33 485.68 194.66 484.36 195 483 C195.66 483 196.32 483 197 483 C197.33 481.68 197.66 480.36 198 479 C198.66 479 199.32 479 200 479 C200.268125 478.27425781 200.53625 477.54851562 200.8125 476.80078125 C201.98670381 474.03135976 203.3394324 471.69080566 205 469.1875 C205.515625 468.39730469 206.03125 467.60710937 206.5625 466.79296875 C207.036875 466.20128906 207.51125 465.60960937 208 465 C208.66 465 209.32 465 210 465 C210.268125 464.27425781 210.53625 463.54851562 210.8125 462.80078125 C211.98670381 460.03135976 213.3394324 457.69080566 215 455.1875 C215.515625 454.39730469 216.03125 453.60710937 216.5625 452.79296875 C217.036875 452.20128906 217.51125 451.60960937 218 451 C218.66 451 219.32 451 220 451 C220 450.01 220 449.02 220 448 C220.66 448 221.32 448 222 448 C222.226875 447.34 222.45375 446.68 222.6875 446 C224.3878815 442.11341372 226.39623084 438.36320183 229 435 C229.66 435 230.32 435 231 435 C231.144375 434.38125 231.28875 433.7625 231.4375 433.125 C232 431 232 431 233 429 C233.66 429 234.32 429 235 429 C235.268125 428.28457031 235.53625 427.56914062 235.8125 426.83203125 C237.01731307 423.95871061 238.41237112 421.36662374 240 418.6875 C240.515625 417.80449219 241.03125 416.92148437 241.5625 416.01171875 C242.036875 415.34785156 242.51125 414.68398438 243 414 C243.66 414 244.32 414 245 414 C245.144375 413.38125 245.28875 412.7625 245.4375 412.125 C246 410 246 410 247 408 C247.66 408 248.32 408 249 408 C249.0825 407.484375 249.165 406.96875 249.25 406.4375 C250.32140225 402.95544268 252.13523605 400.12799115 254 397 C254.66 397 255.32 397 256 397 C256.09152344 396.46117187 256.18304688 395.92234375 256.27734375 395.3671875 C257.22856011 392.25131121 258.81188356 389.87254283 260.5625 387.125 C263.65984641 382.20924364 266.63189419 377.24061284 269.5 372.1875 C269.85006104 371.57084473 270.20012207 370.95418945 270.56079102 370.31884766 C271.37562518 368.88022976 272.18809269 367.44027174 273 366 C273.66 366 274.32 366 275 366 C275.061875 365.319375 275.12375 364.63875 275.1875 363.9375 C276.12661241 360.54224744 277.64622216 358.53141953 279.73828125 355.75 C281.49703568 353.31061305 282.72378578 350.71889116 284 348 C284.72598544 346.54008038 285.45526263 345.08179393 286.1875 343.625 C286.53167969 342.93664062 286.87585938 342.24828125 287.23046875 341.5390625 C287.48441406 341.03117187 287.73835938 340.52328125 288 340 C288.66 340 289.32 340 290 340 C290.16834351 338.91138672 290.16834351 338.91138672 290.34008789 337.80078125 C291.03410363 334.85525831 292.04933947 332.80199675 293.55859375 330.1875 C297.25970098 323.59597271 300.64226887 316.86634888 304.01391602 310.10253906 C305.06162874 308.00174698 306.11361081 305.90313226 307.16601562 303.8046875 C311.89666447 294.34861252 316.47724745 284.84640888 320.5 275.0625 C321.73737632 272.05799562 322.97626502 269.05570302 324.25 266.06640625 C341.24211464 226.08183649 354.07258367 179.39497749 343 136 C342.80132324 135.18885742 342.60264648 134.37771484 342.39794922 133.54199219 C339.49620807 121.91329171 335.59499481 110.95208671 330.734375 100.00390625 C329.28089735 96.72583379 328.06476956 93.42790608 327 90 C326.34 90 325.68 90 325 90 C324.608125 89.175 324.21625 88.35 323.8125 87.5 C322.0487185 84.0940771 320.09154069 80.93579644 317.98828125 77.734375 C317 76 317 76 317 74 C316.34 74 315.68 74 315 74 C313.55473264 72.26451831 312.1912778 70.46024037 310.875 68.625 C310.15054687 67.62726563 309.42609375 66.62953125 308.6796875 65.6015625 C307 63 307 63 307 61 C306.01 60.67 305.02 60.34 304 60 C302.17578125 58.22265625 302.17578125 58.22265625 300.3125 56.0625 C299.37857422 54.99708984 299.37857422 54.99708984 298.42578125 53.91015625 C297 52 297 52 297 50 C296.43152344 49.75378906 295.86304688 49.50757813 295.27734375 49.25390625 C292.61948478 47.79048819 290.75541321 46.03426524 288.5625 43.9375 C284.02975343 39.75029914 279.27563621 36.27123847 274.11547852 32.91967773 C272.71193567 31.99277795 271.35115887 31.00172123 270 30 C270 29.34 270 28.68 270 28 C269.4225 27.87625 268.845 27.7525 268.25 27.625 C265.97664233 26.99351176 264.0746471 26.11141809 262 25 C262 24.34 262 23.68 262 23 C261.30390625 22.90847656 260.6078125 22.81695313 259.890625 22.72265625 C256.38292851 21.84573213 253.8602259 20.28555283 250.75 18.4375 C240.2214706 12.4838673 228.53658092 9.41152111 217 6 C215.82308594 5.62875 214.64617187 5.2575 213.43359375 4.875 C208.68876658 3.66585178 203.91132201 3.02460295 199.0625 2.375 C198.09248047 2.2409375 197.12246094 2.106875 196.12304688 1.96875 C193.7492764 1.64133338 191.37497563 1.31853591 189 1 C189 0.67 189 0.34 189 0 C241.47 0 293.94 0 348 0 C348 168.96 348 337.92 348 512 C233.16 512 118.32 512 0 512 C0 343.04 0 174.08 0 0 Z ",
    fill: "#FAF9F9",
    transform: "translate(0,0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.84175781 0.25394531 1.68351562 0.50789063 2.55078125 0.76953125 C14.02180861 4.58069091 24.45152687 13.03224647 32.9375 21.4375 C33.43942871 21.93314453 33.94135742 22.42878906 34.45849609 22.93945312 C36.90416625 25.47416677 38.60329932 27.4296939 39 31 C39.66 31 40.32 31 41 31 C46.82355276 40.37837653 51.00631623 49.34636424 54 60 C54.36931641 61.22009766 54.36931641 61.22009766 54.74609375 62.46484375 C60.30500939 84.27879545 54.15643115 108.10876454 43 127 C42.34 127 41.68 127 41 127 C41 127.99 41 128.98 41 130 C40.34 130 39.68 130 39 130 C38.64421875 131.08861328 38.64421875 131.08861328 38.28125 132.19921875 C36.8010778 135.43483909 35.03593526 137.33008285 32.5 139.8125 C31.7059375 140.60269531 30.911875 141.39289063 30.09375 142.20703125 C28 144 28 144 26 144 C25.67 144.99 25.34 145.98 25 147 C22.9375 147.6875 22.9375 147.6875 21 148 C21 148.66 21 149.32 21 150 C18.0186204 151.70149442 15.01240433 153.35413572 12 155 C10.66001953 155.75603516 10.66001953 155.75603516 9.29296875 156.52734375 C-8.90485563 166.31085262 -31.99289662 168.38157607 -52 163 C-70.06448571 157.01673648 -85.34081101 147.22171896 -97 132 C-97 131.34 -97 130.68 -97 130 C-97.66 130 -98.32 130 -99 130 C-99 129.01 -99 128.02 -99 127 C-99.66 127 -100.32 127 -101 127 C-105.69216569 118.20877945 -109.47748007 109.69712434 -112 100 C-112.22558594 99.23042969 -112.45117188 98.46085937 -112.68359375 97.66796875 C-117.89139915 77.15999026 -112.53508426 55.34020991 -103 37 C-102.34 37 -101.68 37 -101 37 C-100.84724609 36.14148438 -100.84724609 36.14148438 -100.69140625 35.265625 C-98.45604465 27.94071128 -90.73436544 20.83795889 -85 16 C-84.34 16 -83.68 16 -83 16 C-82.67 15.01 -82.34 14.02 -82 13 C-77.66666667 10 -77.66666667 10 -75 10 C-75 9.34 -75 8.68 -75 8 C-52.00983075 -4.27061507 -25.14786014 -9.46782053 0 0 Z ",
    fill: "#F6F5F5",
    transform: "translate(203,93)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C4.37402501 1.07116382 6.75000677 1.08409085 9.125 1.0625 C11.39375 1.041875 13.6625 1.02125 16 1 C16 5.95 16 10.9 16 16 C11.05 16 6.1 16 1 16 C1 20.95 1 25.9 1 31 C5.95 31 10.9 31 16 31 C16 35.95 16 40.9 16 46 C11.05 46 6.1 46 1 46 C1 50.95 1 55.9 1 61 C5.95 61 10.9 61 16 61 C16 65.95 16 70.9 16 76 C11.05 76 6.1 76 1 76 C1 80.95 1 85.9 1 91 C5.95 91 10.9 91 16 91 C16 95.95 16 100.9 16 106 C11.05 106 6.1 106 1 106 C1 110.95 1 115.9 1 121 C-3.95 121 -8.9 121 -14 121 C-14 116.05 -14 111.1 -14 106 C-18.95 106 -23.9 106 -29 106 C-29 101.05 -29 96.1 -29 91 C-33.62 91.33 -38.24 91.66 -43 92 C-42.34 90.02 -41.68 88.04 -41 86 C-40.34 86 -39.68 86 -39 86 C-38.887771 85.27425781 -38.77554199 84.54851562 -38.65991211 83.80078125 C-37.96589637 80.85525831 -36.95066053 78.80199675 -35.44140625 76.1875 C-31.74029902 69.59597271 -28.35773113 62.86634888 -24.98608398 56.10253906 C-23.93837126 54.00174698 -22.88638919 51.90313226 -21.83398438 49.8046875 C-17.10333553 40.34861252 -12.52275255 30.84640888 -8.5 21.0625 C-8.09265625 20.07507813 -7.6853125 19.08765625 -7.265625 18.0703125 C-6.84796875 17.05710937 -6.4303125 16.04390625 -6 15 C-4.67298462 11.8315644 -3.34487991 8.66359042 -2.015625 5.49609375 C-1.28019662 3.68863708 -0.61707005 1.85121016 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(329,254)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C19.95 15 24.9 15 30 15 C30 10.05 30 5.1 30 0 C34.95 0 39.9 0 45 0 C45 4.95 45 9.9 45 15 C49.95 15 54.9 15 60 15 C60 10.05 60 5.1 60 0 C64.95 0 69.9 0 75 0 C75 4.95 75 9.9 75 15 C79.95 15 84.9 15 90 15 C90 10.05 90 5.1 90 0 C94.95 0 99.9 0 105 0 C105 4.95 105 9.9 105 15 C109.95 15 114.9 15 120 15 C120 10.05 120 5.1 120 0 C124.95 0 129.9 0 135 0 C135 4.95 135 9.9 135 15 C139.95 15 144.9 15 150 15 C150 15.66 150 16.32 150 17 C100.5 17 51 17 0 17 C0 11.39 0 5.78 0 0 Z ",
    fill: "#F0EFEF",
    transform: "translate(0,495)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C16.13288783 3.58508618 29.23995621 11.85122465 40.9375 23.4375 C41.69039307 24.1809668 41.69039307 24.1809668 42.45849609 24.93945312 C44.90416625 27.47416677 46.60329932 29.4296939 47 33 C47.66 33 48.32 33 49 33 C58.86484562 49.26176452 58.86484562 49.26176452 60 57 C59.505 57.99 59.505 57.99 59 59 C54.38 59 49.76 59 45 59 C45 54.05 45 49.1 45 44 C40.05 44 35.1 44 30 44 C30 39.05 30 34.1 30 29 C25.05 29 20.1 29 15 29 C15 24.05 15 19.1 15 14 C10.05 14 5.1 14 0 14 C0 9.38 0 4.76 0 0 Z ",
    fill: "#EFEDED",
    transform: "translate(195,91)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C19.95 15 24.9 15 30 15 C30 19.95 30 24.9 30 30 C34.95 30 39.9 30 45 30 C45 34.95 45 39.9 45 45 C49.95 45 54.9 45 60 45 C60 49.95 60 54.9 60 60 C53.565 60.495 53.565 60.495 47 61 C47 60.34 47 59.68 47 59 C46.34 59 45.68 59 45 59 C43.55473264 57.26451831 42.1912778 55.46024037 40.875 53.625 C40.15054688 52.62726563 39.42609375 51.62953125 38.6796875 50.6015625 C37 48 37 48 37 46 C36.01 45.67 35.02 45.34 34 45 C32.17578125 43.22265625 32.17578125 43.22265625 30.3125 41.0625 C29.68988281 40.35222656 29.06726563 39.64195313 28.42578125 38.91015625 C27 37 27 37 27 35 C26.43152344 34.75378906 25.86304688 34.50757813 25.27734375 34.25390625 C22.61948478 32.79048819 20.75541321 31.03426524 18.5625 28.9375 C15.67335551 26.21246237 12.91992205 23.85970422 9.45703125 21.93359375 C5.90433127 19.92215983 2.83868348 17.99566137 0 15 C-1.18735167 9.37836814 -0.69404252 5.92605538 0 0 Z ",
    fill: "#F0EEEE",
    transform: "translate(270,15)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.29 0 8.58 0 13 0 C13 4.95 13 9.9 13 15 C17.95 15 22.9 15 28 15 C28 19.95 28 24.9 28 30 C32.95 30 37.9 30 43 30 C43 34.95 43 39.9 43 45 C47.95 45 52.9 45 58 45 C58 49.29 58 53.58 58 58 C52.38549733 59.12290053 50.15587646 58.09462117 45.375 55.5625 C44.66641846 55.19487549 43.95783691 54.82725098 43.2277832 54.44848633 C33.8350331 49.45981903 17.90548346 40.40615602 14.1953125 29.671875 C14.13085938 29.12015625 14.06640625 28.5684375 14 28 C13.34 28 12.68 28 12 28 C12 27.01 12 26.02 12 25 C11.34 25 10.68 25 10 25 C0 5.49315068 0 5.49315068 0 0 Z ",
    fill: "#EFEDED",
    transform: "translate(92,195)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3.25467041 0.54487061 3.50934082 1.08974121 3.77172852 1.65112305 C10.22353301 15.40691085 16.99438652 28.95785535 24.04711914 42.4128418 C24.36120728 43.01383194 24.67529541 43.61482208 24.99890137 44.23402405 C25.85387664 45.86894235 26.71210282 47.50215942 27.57055664 49.13525391 C28.86013519 51.71969707 29.97467747 54.30158689 31 57 C30 58 30 58 26.62109375 58.09765625 C25.22652508 58.09191424 23.83198403 58.07890228 22.4375 58.0625 C19.983125 58.041875 17.52875 58.02125 15 58 C15 53.05 15 48.1 15 43 C10.05 43 5.1 43 0 43 C0 38.05 0 33.1 0 28 C-4.95 28 -9.9 28 -15 28 C-15 23.05 -15 18.1 -15 13 C-10.05 13 -5.1 13 0 13 C0 8.71 0 4.42 0 0 Z ",
    fill: "#F4F1F1",
    transform: "translate(30,287)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C16.42145797 11.46379528 16.42145797 11.46379528 15 17 C11.62531194 21.08544326 7.51538329 23.31780825 3 26 C1.25463721 27.47818995 -0.45817586 28.99628351 -2.125 30.5625 C-5.78362573 34 -5.78362573 34 -8 34 C-8 34.66 -8 35.32 -8 36 C-8.66 36 -9.32 36 -10 36 C-10.226875 36.53625 -10.45375 37.0725 -10.6875 37.625 C-12.43382056 40.78500863 -14.6402849 43.2676983 -17 46 C-17.66 45.67 -18.32 45.34 -19 45 C-22.67015275 44.8622315 -26.32611348 44.95728039 -30 45 C-30 40.05 -30 35.1 -30 30 C-25.05 30 -20.1 30 -15 30 C-15 25.05 -15 20.1 -15 15 C-10.05 15 -5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEDED",
    transform: "translate(60,15)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.29 0 8.58 0 13 0 C14.33875616 4.01626847 12.86980896 6.28946386 11.3125 10 C7.99903989 18.3317551 6.02722208 26.74534973 4.44165039 35.55541992 C4.13559353 37.24947594 3.80773081 38.93968182 3.46264648 40.6262207 C1.73761214 49.6410909 1.55993865 58.54032297 1.5625 67.6875 C1.56089874 68.90613235 1.56089874 68.90613235 1.55926514 70.14938354 C1.59595972 89.58345217 5.12694473 107.45384698 11.20751953 125.90063477 C13.09937495 131.70187515 13.09937495 131.70187515 12 135 C8.04 135 4.08 135 0 135 C0 90.45 0 45.9 0 0 Z ",
    fill: "#EFEBEB",
    transform: "translate(0,105)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.64338271 3.05005697 4.77512557 6.21904755 6.8125 9.6875 C9.46438436 14.19906023 12.38215063 18.44372005 15.41796875 22.703125 C17.05371971 25.07799307 18.45175523 27.5369378 19.8203125 30.07421875 C22.08146871 33.76544395 24.83276102 37.13331578 27.48828125 40.546875 C27.98714844 41.35640625 28.48601562 42.1659375 29 43 C28.67 43.99 28.34 44.98 28 46 C24.37 46 20.74 46 17 46 C17 41.05 17 36.1 17 31 C12.05 31 7.1 31 2 31 C2 26.05 2 21.1 2 16 C-2.95 16 -7.9 16 -13 16 C-13 11.05 -13 6.1 -13 1 C-9.90755208 1.03255208 -6.81510417 1.06510417 -3.72265625 1.09765625 C-1.08552366 1.31262571 -1.08552366 1.31262571 0 0 Z ",
    fill: "#EFECEC",
    transform: "translate(88,389)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C19.95 15 24.9 15 30 15 C30 10.05 30 5.1 30 0 C34.95 0 39.9 0 45 0 C45 4.62 45 9.24 45 14 C45.66 14.33 46.32 14.66 47 15 C40.54187448 18.72584164 33.16590881 18.19276852 25.9375 18.1875 C24.9155957 18.18741943 23.89369141 18.18733887 22.84082031 18.18725586 C14.37989088 18.12352383 6.09007791 17.69669264 -2 15 C-2 14.34 -2 13.68 -2 13 C-1.34 13 -0.68 13 0 13 C0 8.71 0 4.42 0 0 Z ",
    fill: "#FEFDFD",
    transform: "translate(150,240)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C4.37402501 1.07116382 6.75000677 1.08409085 9.125 1.0625 C11.39375 1.041875 13.6625 1.02125 16 1 C16 5.95 16 10.9 16 16 C11.05 16 6.1 16 1 16 C1 20.95 1 25.9 1 31 C-2.05989583 31.22786458 -5.11979167 31.45572917 -8.1796875 31.68359375 C-10.94728971 31.83001703 -10.94728971 31.83001703 -13 33 C-11.5781719 28.2143347 -9.95116294 23.73734623 -7.625 19.3125 C-4.40353727 13.11436654 -2.23648717 6.60477489 0 0 Z ",
    fill: "#EFEBEB",
    transform: "translate(329,254)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.2837225 0.00713853 6.56591455 0.18614237 9.84375 0.3828125 C9.84375 5.3328125 9.84375 10.2828125 9.84375 15.3828125 C4.89375 15.3828125 -0.05625 15.3828125 -5.15625 15.3828125 C-5.15625 20.3328125 -5.15625 25.2828125 -5.15625 30.3828125 C-8.78625 30.3828125 -12.41625 30.3828125 -16.15625 30.3828125 C-17.28125 25.8828125 -17.28125 25.8828125 -15.72265625 22.4921875 C-15.40361328 21.78320312 -15.08457031 21.07421875 -14.75585938 20.34375 C-14.41361328 19.61414063 -14.07136719 18.88453125 -13.71875 18.1328125 C-13.38037109 17.38773438 -13.04199219 16.64265625 -12.69335938 15.875 C-11.85798696 14.03953385 -11.00847033 12.21051695 -10.15625 10.3828125 C-9.49625 10.3828125 -8.83625 10.3828125 -8.15625 10.3828125 C-8.07375 9.8465625 -7.99125 9.3103125 -7.90625 8.7578125 C-5.34535864 0.6483232 -5.34535864 0.6483232 0 0 Z ",
    fill: "#EFEDED",
    transform: "translate(110.15625,119.6171875)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 4.95 0 9.9 0 15 C-4.95 15 -9.9 15 -15 15 C-15 19.95 -15 24.9 -15 30 C-19.62 30.33 -24.24 30.66 -29 31 C-28.34 29.02 -27.68 27.04 -27 25 C-26.34 25 -25.68 25 -25 25 C-24.89300781 24.28457031 -24.78601563 23.56914062 -24.67578125 22.83203125 C-23.93425398 19.72447478 -22.77054453 17.456826 -21.1875 14.6875 C-19.26743251 11.29293092 -17.45629888 7.91107899 -15.8125 4.375 C-12.47315775 -1.84308557 -6.36337889 -0.07486328 0 0 Z ",
    fill: "#EFECEC",
    transform: "translate(315,315)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.50663715 6.07817107 3.19260935 12.87417609 3.1875 19.6875 C3.18814453 20.57147461 3.18878906 21.45544922 3.18945312 22.36621094 C3.13799437 28.74007947 2.59130171 34.80528977 1 41 C-1 39 -1 39 -1.1953125 36.1796875 C-1.13020833 33.11979167 -1.06510417 30.05989583 -1 27 C-5.95 27 -10.9 27 -16 27 C-16 22.05 -16 17.1 -16 12 C-11.05 12 -6.1 12 -1 12 C-1.020625 10.39125 -1.04125 8.7825 -1.0625 7.125 C-1.125 2.25 -1.125 2.25 0 0 Z ",
    fill: "#F1EEEE",
    transform: "translate(256,153)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 4.95 12 9.9 12 15 C16.95 15 21.9 15 27 15 C27 19.95 27 24.9 27 30 C23.37 30.33 19.74 30.66 16 31 C14.82845707 28.71070947 13.66261926 26.41881638 12.5 24.125 C12.16613281 23.47402344 11.83226562 22.82304688 11.48828125 22.15234375 C9 17.2265625 9 17.2265625 9 15 C8.34 15 7.68 15 7 15 C6.5875 14.154375 6.175 13.30875 5.75 12.4375 C4.49730894 9.97685684 3.21062139 7.62332349 1.8125 5.25 C0 2 0 2 0 0 Z ",
    fill: "#FEFCFD",
    transform: "translate(318,75)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C17.82 0 35.64 0 54 0 C54 0.33 54 0.66 54 1 C53.23147705 1.11480713 52.4629541 1.22961426 51.67114258 1.34790039 C35.89522685 3.75407724 20.90129639 6.63136306 5.92163086 12.32324219 C3.98664008 13.00470508 1.99023049 13.50244238 0 14 C0 9.38 0 4.76 0 0 Z ",
    fill: "#EFECEC",
    transform: "translate(105,0)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 21.12 1 42.24 1 64 C0.01 64 -0.98 64 -2 64 C-2 68.95 -2 73.9 -2 79 C-4.97 79 -7.94 79 -11 79 C-12.17780252 75.46659244 -11.74762407 74.40621445 -10.671875 70.9140625 C-10.36781738 69.90698242 -10.06375977 68.89990234 -9.75048828 67.86230469 C-9.25524658 66.25983887 -9.25524658 66.25983887 -8.75 64.625 C-8.09396098 62.43561151 -7.44029134 60.24551158 -6.7890625 58.0546875 C-6.47614258 57.0037793 -6.16322266 55.95287109 -5.84082031 54.87011719 C-1.75080883 40.90897462 -0.91730982 27.23868334 -0.4375 12.75 C-0.39431641 11.51636719 -0.35113281 10.28273437 -0.30664062 9.01171875 C-0.20185595 6.00789133 -0.0996846 3.00400025 0 0 Z ",
    fill: "#F6EFEF",
    transform: "translate(347,161)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C16.83 0 33.66 0 51 0 C51 3.63 51 7.26 51 11 C47.04369513 11.98907622 46.29254023 12.05509201 42.69921875 10.85546875 C41.88646484 10.59056641 41.07371094 10.32566406 40.23632812 10.05273438 C39.39521484 9.76720703 38.55410156 9.48167969 37.6875 9.1875 C36.0250099 8.63850366 34.36225343 8.09031323 32.69921875 7.54296875 C31.48770142 7.14416504 31.48770142 7.14416504 30.25170898 6.73730469 C23.54611659 4.54161033 17.03669498 3.30934191 10.0625 2.375 C9.09248047 2.2409375 8.12246094 2.106875 7.12304688 1.96875 C4.7492764 1.64133338 2.37497563 1.31853591 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#EFEBEB",
    transform: "translate(189,0)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C4.98565046 2.60613909 8.97274969 2.74564735 13 3 C13 7.95 13 12.9 13 18 C8.05 18 3.1 18 -2 18 C-2.33 15.03 -2.66 12.06 -3 9 C-4.32 9.99 -5.64 10.98 -7 12 C-5.44298069 7.32894208 -2.91552627 3.91294315 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(242,417)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2.33 1.98 2.66 3.96 3 6 C2.67 6 2.34 6 2 6 C1.67 9.63 1.34 13.26 1 17 C-3.95 17 -8.9 17 -14 17 C-14 12.05 -14 7.1 -14 2 C-9.38 2 -4.76 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FEFDFD",
    transform: "translate(29,283)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C5.95 2 10.9 2 16 2 C16 6.95 16 11.9 16 17 C11.05 17 6.1 17 1 17 C0.8046875 13.64713542 0.609375 10.29427083 0.4140625 6.94140625 C0.27742188 5.97074219 0.14078125 5.00007813 0 4 C-0.66 3.67 -1.32 3.34 -2 3 C-1.34 2.01 -0.68 1.02 0 0 Z ",
    fill: "#EEECEC",
    transform: "translate(269,373)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 4.95 1 9.9 1 15 C5.62 15 10.24 15 15 15 C15 19.95 15 24.9 15 30 C10.71 30 6.42 30 2 30 C-0.28487759 23.65811536 -0.23299776 17.75420732 -0.125 11.0625 C-0.11597656 9.99708984 -0.10695313 8.93167969 -0.09765625 7.83398438 C-0.07423414 5.22241966 -0.04143452 2.61133063 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(90,165)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15.33 5.28 15.66 10.56 16 16 C10.72 15.67 5.44 15.34 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(240,180)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.19896869 4.39793738 0.37969311 11.35930648 0 16 C-4.95 16 -9.9 16 -15 16 C-15 11.05 -15 6.1 -15 1 C-10.05 0.67 -5.1 0.34 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(60,344)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(330,495)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(300,495)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(270,495)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(240,495)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(225,495)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(195,495)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(135,495)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(105,495)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(75,495)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(45,495)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(15,495)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(315,480)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(300,480)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(285,480)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(270,480)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(255,480)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(240,480)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(225,480)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(210,480)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(120,480)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(105,480)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(90,480)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(75,480)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(60,480)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(45,480)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(30,480)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(15,480)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(0,480)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(330,465)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(315,465)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(300,465)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(285,465)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(270,465)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(255,465)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(240,465)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(225,465)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(120,465)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(105,465)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(90,465)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(75,465)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(60,465)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(45,465)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(30,465)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(15,465)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(0,465)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(315,450)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(300,450)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(285,450)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(270,450)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(255,450)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(240,450)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(225,450)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(105,450)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(90,450)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(75,450)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(60,450)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(45,450)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(30,450)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(15,450)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(0,450)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(330,435)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(315,435)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(300,435)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(285,435)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(270,435)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(255,435)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(240,435)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(90,435)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(75,435)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(60,435)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(45,435)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(30,435)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(15,435)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(0,435)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(315,420)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(300,420)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(285,420)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(270,420)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(255,420)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(90,420)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(75,420)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(60,420)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(45,420)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(30,420)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(15,420)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(0,420)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(330,405)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(315,405)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(300,405)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(285,405)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(270,405)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(255,405)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(75,405)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(60,405)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(45,405)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(30,405)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(15,405)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(0,405)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(315,390)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(300,390)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(285,390)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(270,390)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(60,390)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(45,390)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(30,390)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(15,390)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(0,390)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(330,375)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(315,375)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(300,375)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(285,375)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(60,375)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(45,375)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(30,375)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(15,375)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(0,375)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(315,360)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(300,360)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(285,360)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(45,360)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(30,360)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(15,360)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(0,360)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(330,345)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(315,345)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(300,345)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(30,345)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(15,345)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(0,345)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(300,330)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(30,330)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(15,330)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(0,330)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(330,315)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(315,315)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(15,315)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(0,315)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(330,300)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(0,300)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(330,285)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(0,285)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(330,270)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(0,270)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(0,255)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(165,240)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(195,225)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(180,225)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(165,225)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(150,225)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(135,225)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(210,210)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(195,210)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(180,210)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(165,210)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(150,210)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(135,210)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(120,210)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(225,195)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(210,195)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(195,195)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(180,195)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(165,195)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(150,195)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(135,195)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(120,195)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(105,195)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(225,180)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(210,180)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(195,180)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(180,180)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(165,180)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(150,180)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(135,180)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(120,180)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(225,165)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(210,165)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(195,165)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(180,165)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(165,165)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(150,165)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(135,165)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(120,165)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(105,165)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(225,150)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(210,150)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(195,150)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(180,150)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(165,150)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(150,150)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(135,150)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(120,150)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(105,150)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(225,135)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(210,135)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(195,135)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(180,135)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(165,135)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(150,135)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(135,135)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(105,135)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(210,120)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(195,120)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(180,120)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(165,120)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(150,120)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(135,120)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(120,120)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(195,105)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(180,105)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(165,105)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(150,105)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(135,105)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(165,90)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(330,75)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(0,75)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(330,60)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(15,60)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(0,60)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(330,45)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(315,45)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(15,45)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(0,45)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(330,30)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(315,30)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(300,30)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(30,30)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(15,30)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(0,30)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(330,15)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(315,15)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(300,15)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(285,15)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(45,15)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(30,15)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(15,15)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(0,15)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(315,0)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(300,0)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(285,0)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(270,0)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(255,0)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(75,0)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(60,0)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(45,0)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(30,0)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C16.171875 8.984375 16.171875 8.984375 16 12 C14.015625 14.390625 14.015625 14.390625 12 16 C11.67 15.67 11.34 15.34 11 15 C7.3308423 14.85689713 3.67284559 14.95778338 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEDED",
    transform: "translate(30,45)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 4.95 0 9.9 0 15 C-4.95 15 -9.9 15 -15 15 C-16.28548271 5.28746398 -16.28548271 5.28746398 -15 2 C-10.25368713 -1.16420858 -5.63243123 -0.12112755 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(330,285)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.62 0 9.24 0 14 0 C14 4.95 14 9.9 14 15 C9.38 15 4.76 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(91,165)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C16.35304209 4.05912626 15.15216503 5.77149591 13.5625 9.6875 C13.08941406 10.86699219 12.61632812 12.04648438 12.12890625 13.26171875 C11.75636719 14.16535156 11.38382813 15.06898438 11 16 C7.37 15.67 3.74 15.34 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEBEB",
    transform: "translate(240,195)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.97 0 5.94 0 9 0 C9 4.95 9 9.9 9 15 C4.05 15 -0.9 15 -6 15 C-6.33 14.34 -6.66 13.68 -7 13 C-7.99 13.66 -8.98 14.32 -10 15 C-8.79618552 12.50638429 -7.54571278 10.31856917 -6 8 C-5.34 8 -4.68 8 -4 8 C-3.67 6.68 -3.34 5.36 -3 4 C-2.34 4 -1.68 4 -1 4 C-0.67 2.68 -0.34 1.36 0 0 Z ",
    fill: "#EFECEC",
    transform: "translate(186,495)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 3.63 15 7.26 15 11 C5.625 15.125 5.625 15.125 0 14 C0 9.38 0 4.76 0 0 Z ",
    fill: "#EFECEC",
    transform: "translate(195,240)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.3 0.33 6.6 0.66 10 1 C10 5.95 10 10.9 10 16 C5.05 16.33 0.1 16.66 -5 17 C-5 11.36138614 -5 11.36138614 -3.625 7.9375 C-3.36976563 7.28652344 -3.11453125 6.63554687 -2.8515625 5.96484375 C-1.97520081 3.94277986 -0.98557112 1.97114224 0 0 Z ",
    fill: "#FEFCFD",
    transform: "translate(335,239)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.13209391 2.75290949 4.01356503 5.54416744 5.75 8.5625 C6.19859375 9.32691406 6.6471875 10.09132813 7.109375 10.87890625 C8 13 8 13 7 16 C2.05 16 -2.9 16 -8 16 C-8 11.05 -8 6.1 -8 1 C-5.69 1 -3.38 1 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#EFEAEA",
    transform: "translate(53,329)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.64750929 2.47126394 2.93723705 4.7609443 4.1875 7.4375 C4.55230469 8.19933594 4.91710938 8.96117187 5.29296875 9.74609375 C6 12 6 12 5 16 C0.38 16 -4.24 16 -9 16 C-9 11.05 -9 6.1 -9 1 C-7.700625 1.020625 -6.40125 1.04125 -5.0625 1.0625 C-3.70834367 1.08399454 -2.35243917 1.07148199 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#EFEBEB",
    transform: "translate(24,269)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.29 15 8.58 15 13 C9.66419646 14.06716071 8.79373365 13.83786843 4.1875 11.5625 C3.21167969 11.08941406 2.23585937 10.61632812 1.23046875 10.12890625 C0.49441406 9.75636719 -0.24164063 9.38382813 -1 9 C-0.67 6.03 -0.34 3.06 0 0 Z ",
    fill: "#EFEBEB",
    transform: "translate(135,240)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.54436129 1.28708387 10.70201036 2.91864693 16 5 C15.67 7.97 15.34 10.94 15 14 C10.05 14 5.1 14 0 14 C0 9.38 0 4.76 0 0 Z ",
    fill: "#EFEBEB",
    transform: "translate(195,91)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C2 8.26 2 15.52 2 23 C-4.435 23.495 -4.435 23.495 -11 24 C-9.71785687 20.15357062 -8.62257334 16.99878744 -6.8359375 13.4765625 C-6.43632812 12.68378906 -6.03671875 11.89101563 -5.625 11.07421875 C-5.2125 10.26597656 -4.8 9.45773437 -4.375 8.625 C-3.95476562 7.79355469 -3.53453125 6.96210938 -3.1015625 6.10546875 C-2.07133925 4.06843641 -1.03741179 2.03337811 0 0 Z ",
    fill: "#FCF8F8",
    transform: "translate(313,292)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 4.29 0 8.58 0 13 C-4.95 13 -9.9 13 -15 13 C-15 7 -15 7 -13 4 C-10.72265625 2.83203125 -10.72265625 2.83203125 -8.0625 1.8125 C-6.74958984 1.29623047 -6.74958984 1.29623047 -5.41015625 0.76953125 C-3 0 -3 0 0 0 Z ",
    fill: "#EFEBEB",
    transform: "translate(150,92)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C4.68955976 2.39611639 4.37671642 4.79187835 4.0625 7.1875 C3.97548828 7.86103516 3.88847656 8.53457031 3.79882812 9.22851562 C3.08846281 14.62203004 3.08846281 14.62203004 2.47705078 17.234375 C1.85637653 20.8326339 1.83755433 24.37992124 1.83203125 28.01953125 C1.82870285 28.7957634 1.82537445 29.57199554 1.82194519 30.37174988 C1.81689208 32.01662609 1.81453637 33.66151252 1.81469727 35.30639648 C1.81254051 37.76629739 1.79445132 40.225727 1.77539062 42.68554688 C1.7445168 51.93499596 2.27847747 60.82993288 3.66674805 69.97924805 C4 73 4 73 3 75 C2.01 75 1.02 75 0 75 C0 50.25 0 25.5 0 0 Z ",
    fill: "#F3EBEB",
    transform: "translate(0,135)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C12.87 0 25.74 0 39 0 C39 0.33 39 0.66 39 1 C38.15816162 1.14099121 37.31632324 1.28198242 36.44897461 1.42724609 C33.29689902 1.95711245 30.14545561 2.49056063 26.99438477 3.02636719 C25.63590005 3.2566243 24.27717911 3.48549258 22.91821289 3.71289062 C20.95395924 4.04182917 18.99064142 4.3763404 17.02734375 4.7109375 C15.25991821 5.00943604 15.25991821 5.00943604 13.45678711 5.31396484 C9.91905054 5.96358111 9.91905054 5.96358111 6.21313477 7.10400391 C3.15418359 7.95700526 1.88387763 8.15355105 -1 7 C-0.67 4.69 -0.34 2.38 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(120,0)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C11.88 0 23.76 0 36 0 C36.495 3.465 36.495 3.465 37 7 C35.64509704 6.88325099 34.29109304 6.75606577 32.9375 6.625 C31.80634766 6.52058594 31.80634766 6.52058594 30.65234375 6.4140625 C28 6 28 6 24.875 5.0625 C20.03005233 3.62049662 15.06157693 3.0447328 10.0625 2.375 C9.09248047 2.2409375 8.12246094 2.106875 7.12304688 1.96875 C4.7492764 1.64133338 2.37497563 1.31853591 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#FCF7F8",
    transform: "translate(189,0)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.23176279 2.53905767 6.91655857 4.6737173 10.3125 8.125 C11.19550781 9.01445313 12.07851562 9.90390625 12.98828125 10.8203125 C15 13 15 13 15 14 C10.05 14 5.1 14 0 14 C0 9.38 0 4.76 0 0 Z ",
    fill: "#FDFCFC",
    transform: "translate(225,106)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.57161458 0.03255208 5.14322917 0.06510417 7.71484375 0.09765625 C7.71484375 5.04765625 7.71484375 9.99765625 7.71484375 15.09765625 C6.06484375 15.09765625 4.41484375 15.09765625 2.71484375 15.09765625 C1.99869792 13.37239583 1.28255208 11.64713542 0.56640625 9.921875 C-0.35322317 7.83231693 -0.35322317 7.83231693 -2.28515625 5.09765625 C-2.97265625 2.97265625 -2.97265625 2.97265625 -3.28515625 1.09765625 C-2.28515625 0.09765625 -2.28515625 0.09765625 0 0 Z ",
    fill: "#EFECEC",
    transform: "translate(337.28515625,104.90234375)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0 2.64 0 4 0 C4 4.95 4 9.9 4 15 C1.03 15 -1.94 15 -5 15 C-6.18414294 11.44757118 -5.69535532 10.30169438 -4.5625 6.8125 C-4.27503906 5.91144531 -3.98757813 5.01039063 -3.69140625 4.08203125 C-3.46324219 3.39496094 -3.23507812 2.70789063 -3 2 C-2.34 2 -1.68 2 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#EFE9E9",
    transform: "translate(341,225)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.29 0.33 8.58 0.66 13 1 C13 5.29 13 9.58 13 14 C13.66 14.33 14.32 14.66 15 15 C10.60962679 14.56096268 8.17535669 11.61945961 5.25 8.625 C4.74339844 8.13 4.23679687 7.635 3.71484375 7.125 C0 3.38011708 0 3.38011708 0 0 Z ",
    fill: "#FCF8F8",
    transform: "translate(107,224)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 0.66 15 1.32 15 2 C13.11658031 3.61393669 11.24272703 5.09576022 9.25 6.5625 C8.44175781 7.1802832 8.44175781 7.1802832 7.6171875 7.81054688 C4.64251092 10.02704369 2.6666013 11.08334968 -1 12 C-0.67 8.04 -0.34 4.08 0 0 Z ",
    fill: "#FCF6F6",
    transform: "translate(60,30)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2.8515625 3.546875 C3.10679687 4.60390625 3.36203125 5.6609375 3.625 6.75 C3.88539063 7.79671875 4.14578125 8.8434375 4.4140625 9.921875 C4.94535644 12.71293916 5.1152681 15.17069211 5 18 C2.36 17.67 -0.28 17.34 -3 17 C-3 12.05 -3 7.1 -3 2 C-2.01 2 -1.02 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FCF6F6",
    transform: "translate(3,208)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.29065057 3.8719517 0.22324098 6.44232601 -0.9375 10.1875 C-1.13279297 10.84169922 -1.32808594 11.49589844 -1.52929688 12.16992188 C-2.01182563 13.78227407 -2.50490205 15.39146289 -3 17 C-4.65 17 -6.3 17 -8 17 C-8 12.05 -8 7.1 -8 2 C-5.36 2 -2.72 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(8,118)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 4.62 0 9.24 0 14 C-3.63 14.33 -7.26 14.66 -11 15 C-9.85281905 10.88926827 -5.34120221 0 0 0 Z ",
    fill: "#FDFBFB",
    transform: "translate(210,466)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 4.62 0 9.24 0 14 C-2.27864583 14.1953125 -4.55729167 14.390625 -6.8359375 14.5859375 C-9.20334191 14.82892588 -9.20334191 14.82892588 -11 17 C-10.42871757 12.71146888 -8.90905605 9.86008623 -6.5625 6.25 C-5.94503906 5.28578125 -5.32757813 4.3215625 -4.69140625 3.328125 C-2.27348993 0 -2.27348993 0 0 0 Z ",
    fill: "#FCF7F8",
    transform: "translate(270,376)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.23077598 3.80770026 5.8043091 7.52729632 8 12 C7.75 14.4375 7.75 14.4375 7 16 C4.36 16 1.72 16 -1 16 C-1.02692484 13.70839681 -1.04636124 11.41670454 -1.0625 9.125 C-1.07410156 7.84882813 -1.08570313 6.57265625 -1.09765625 5.2578125 C-1 2 -1 2 0 0 Z ",
    fill: "#EFE9E9",
    transform: "translate(61,344)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3 5.61 3 11.22 3 17 C-2.94 17 -8.88 17 -15 17 C-15 16.34 -15 15.68 -15 15 C-10.05 15 -5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(345,495)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C3.6875 3.0625 3.6875 3.0625 4 5 C4.66 5 5.32 5 6 5 C6.33 6.32 6.66 7.64 7 9 C7.66 9 8.32 9 9 9 C9.33 10.65 9.66 12.3 10 14 C6.7 13.67 3.4 13.34 0 13 C0 8.71 0 4.42 0 0 Z ",
    fill: "#FDFAFA",
    transform: "translate(150,482)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 3.63 0 7.26 0 11 C-3.63 11 -7.26 11 -11 11 C-11.33 11.66 -11.66 12.32 -12 13 C-11.46960703 8.942959 -9.42356448 7.05155434 -6.5625 4.25 C-5.75941406 3.45078125 -4.95632812 2.6515625 -4.12890625 1.828125 C-2 0 -2 0 0 0 Z ",
    fill: "#FDFCFC",
    transform: "translate(120,109)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.32184983 1.08046246 4.64208263 1.27819498 6.8125 4.8125 C7.47185547 5.84310547 7.47185547 5.84310547 8.14453125 6.89453125 C9.15965671 9.39294506 8.91191297 10.51042165 8 13 C5.36 12.67 2.72 12.34 0 12 C0 8.04 0 4.08 0 0 Z ",
    fill: "#FCF7F7",
    transform: "translate(240,123)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.01981934 0.61294922 1.03963867 1.22589844 1.06005859 1.85742188 C1.44964564 13.36853534 1.98510642 24.71581196 3.6953125 36.11328125 C4 39 4 39 3 41 C2.01 41 1.02 41 0 41 C0 27.47 0 13.94 0 0 Z ",
    fill: "#F1E3E4",
    transform: "translate(0,169)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.63 0 7.26 0 11 0 C10.34 1.32 9.68 2.64 9 4 C8.34 4 7.68 4 7 4 C7 4.66 7 5.32 7 6 C6.34 6 5.68 6 5 6 C4.731875 6.639375 4.46375 7.27875 4.1875 7.9375 C3 10 3 10 0 11 C0 7.37 0 3.74 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(45,45)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3.83790789 1.78953185 4.67019396 3.58169695 5.5 5.375 C5.9640625 6.37273437 6.428125 7.37046875 6.90625 8.3984375 C8 11 8 11 8 13 C5.36 13 2.72 13 0 13 C0 8.71 0 4.42 0 0 Z ",
    fill: "#F0E7E7",
    transform: "translate(30,287)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 2.64 12 5.28 12 8 C7.15409462 7.55946315 3.51858133 5.25494123 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FCF5F5",
    transform: "translate(123,240)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.97 0 5.94 0 9 0 C9.06058594 0.75925781 9.12117188 1.51851562 9.18359375 2.30078125 C9.26738281 3.29464844 9.35117187 4.28851563 9.4375 5.3125 C9.51871094 6.29863281 9.59992188 7.28476563 9.68359375 8.30078125 C9.91812559 11.09375599 9.91812559 11.09375599 11 14 C10.34 14 9.68 14 9 14 C7.36951402 11.88389996 5.85923862 9.77726231 4.375 7.5625 C3.95476562 6.95083984 3.53453125 6.33917969 3.1015625 5.70898438 C0 1.1523057 0 1.1523057 0 0 Z ",
    fill: "#FBF6F6",
    transform: "translate(306,60)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.47290409 0.63723011 5.84354753 2.02437217 8.75 4 C9.54921875 4.53625 10.3484375 5.0725 11.171875 5.625 C11.77515625 6.07875 12.3784375 6.5325 13 7 C13 7.33 13 7.66 13 8 C8.71 8 4.42 8 0 8 C0 5.36 0 2.72 0 0 Z ",
    fill: "#FDFBFB",
    transform: "translate(210,97)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 3.3 1 6.6 1 10 C-1.97 10 -4.94 10 -8 10 C-6.59259259 4.37037037 -6.59259259 4.37037037 -3.5 2.4375 C-2.675 1.963125 -1.85 1.48875 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z M-10 10 C-9.01 10.495 -9.01 10.495 -8 11 C-8.99 11.495 -8.99 11.495 -10 12 C-10 11.34 -10 10.68 -10 10 Z ",
    fill: "#F0E9EA",
    transform: "translate(239,425)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C4.97 2.495 4.97 2.495 8 3 C8.33 7.29 8.66 11.58 9 16 C8.34 16 7.68 16 7 16 C7 15.01 7 14.02 7 13 C6.34 13 5.68 13 5 13 C4.15930585 11.39967863 3.32768495 9.79458829 2.5 8.1875 C1.80390625 6.84751953 1.80390625 6.84751953 1.09375 5.48046875 C0 3 0 3 0 0 Z ",
    fill: "#FBF5F5",
    transform: "translate(97,207)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C7.92 0 15.84 0 24 0 C24 0.33 24 0.66 24 1 C20.9398596 1.53537872 17.87666284 2.0506887 14.8125 2.5625 C13.51602539 2.78969727 13.51602539 2.78969727 12.19335938 3.02148438 C4.25311176 4.32964778 4.25311176 4.32964778 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#F1E3E4",
    transform: "translate(135,0)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.78155989 1.26051996 4.25618367 2.56446606 6.25 5.9375 C6.79140625 6.83339844 7.3328125 7.72929687 7.890625 8.65234375 C8.25671875 9.42707031 8.6228125 10.20179688 9 11 C8.67 11.66 8.34 12.32 8 13 C5.69 12.67 3.38 12.34 1 12 C0.67 8.04 0.34 4.08 0 0 Z ",
    fill: "#FBF5F5",
    transform: "translate(89,393)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 3.96 0 7.92 0 12 C-1.65 12.33 -3.3 12.66 -5 13 C-5.66 13.66 -6.32 14.32 -7 15 C-6.23004535 10.22628119 -4.91865756 5.44320697 -3 1 C-1 0 -1 0 0 0 Z ",
    fill: "#FCF7F7",
    transform: "translate(330,258)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.64 0 5.28 0 8 0 C8.12375 1.85625 8.12375 1.85625 8.25 3.75 C8.63475459 6.98882964 8.90024003 7.87907883 11.0625 10.5 C11.701875 10.995 12.34125 11.49 13 12 C12.67 12.99 12.34 13.98 12 15 C10.82739389 13.71372289 9.6620717 12.42080217 8.5 11.125 C7.8503125 10.40570313 7.200625 9.68640625 6.53125 8.9453125 C5 7 5 7 5 5 C4.360625 4.731875 3.72125 4.46375 3.0625 4.1875 C1 3 1 3 0 0 Z ",
    fill: "#FAF9F9",
    transform: "translate(292,45)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C4.38671875 1.4609375 4.38671875 1.4609375 5.6875 3.375 C6.12449219 4.00148438 6.56148438 4.62796875 7.01171875 5.2734375 C8 7 8 7 8 9 C5.36 9 2.72 9 0 9 C0 6.03 0 3.06 0 0 Z ",
    fill: "#F0E8E9",
    transform: "translate(120,441)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3 2.97 3 5.94 3 9 C1.329375 9.4640625 1.329375 9.4640625 -0.375 9.9375 C-3.7945155 10.82326483 -3.7945155 10.82326483 -6 12 C-4.43358249 7.69235185 -2.31663844 3.93828536 0 0 Z ",
    fill: "#F0E8E8",
    transform: "translate(282,351)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3 4.95 3 9.9 3 15 C2.01 15 1.02 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(345,480)"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3 4.95 3 9.9 3 15 C2.01 15 1.02 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(345,465)"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3 4.95 3 9.9 3 15 C2.01 15 1.02 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(345,450)"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3 4.95 3 9.9 3 15 C2.01 15 1.02 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(345,435)"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3 4.95 3 9.9 3 15 C2.01 15 1.02 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(345,420)"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3 4.95 3 9.9 3 15 C2.01 15 1.02 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(345,405)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3 4.95 3 9.9 3 15 C2.01 15 1.02 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(345,390)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3 4.95 3 9.9 3 15 C2.01 15 1.02 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(345,375)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3 4.95 3 9.9 3 15 C2.01 15 1.02 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(345,360)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3 4.95 3 9.9 3 15 C2.01 15 1.02 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(345,345)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3 4.95 3 9.9 3 15 C2.01 15 1.02 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(345,330)"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3 4.95 3 9.9 3 15 C2.01 15 1.02 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(345,315)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3 4.95 3 9.9 3 15 C2.01 15 1.02 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(345,300)"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3 4.95 3 9.9 3 15 C2.01 15 1.02 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(345,285)"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3 4.95 3 9.9 3 15 C2.01 15 1.02 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(345,270)"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3 4.95 3 9.9 3 15 C2.01 15 1.02 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(345,255)"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3 4.95 3 9.9 3 15 C2.01 15 1.02 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(345,225)"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3 4.95 3 9.9 3 15 C2.01 15 1.02 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(345,120)"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3 4.95 3 9.9 3 15 C2.01 15 1.02 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(345,105)"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3 4.95 3 9.9 3 15 C2.01 15 1.02 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(345,90)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3 4.95 3 9.9 3 15 C2.01 15 1.02 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(345,75)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3 4.95 3 9.9 3 15 C2.01 15 1.02 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(345,60)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3 4.95 3 9.9 3 15 C2.01 15 1.02 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(345,30)"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3 4.95 3 9.9 3 15 C2.01 15 1.02 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(345,0)"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C1.67 2.98 1.34 4.96 1 7 C-2.3 7 -5.6 7 -9 7 C-8.67 6.34 -8.34 5.68 -8 5 C-7.34 5 -6.68 5 -6 5 C-6 4.34 -6 3.68 -6 3 C-4.03533587 1.93224776 -2.03144641 0.93446535 0 0 Z ",
    fill: "#FDFBFB",
    transform: "translate(134,98)"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 2.64 1 5.28 1 8 C-1.31 8 -3.62 8 -6 8 C-6.33 8.66 -6.66 9.32 -7 10 C-6.52727227 5.74545047 -4.03562624 3.80795427 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#FCF5F5",
    transform: "translate(194,487)"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C4.25 6.625 4.25 6.625 2 10 C1.34 10 0.68 10 0 10 C0 6.7 0 3.4 0 0 Z ",
    fill: "#F0E9E9",
    transform: "translate(15,90)"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.93 0 13.86 0 21 0 C21 0.66 21 1.32 21 2 C13.70345948 3.43069422 7.26366109 2.33979115 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#F2E2E3",
    transform: "translate(189,0)"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 2.64 0 5.28 0 8 C-2.31 8.33 -4.62 8.66 -7 9 C-4.6 0 -4.6 0 0 0 Z ",
    fill: "#FBF4F4",
    transform: "translate(105,127)"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2.22331199 1.58129029 2.42804644 3.16521089 2.625 4.75 C2.74101562 5.63171875 2.85703125 6.5134375 2.9765625 7.421875 C3.00207817 10.22859878 2.44843844 11.63384866 1 14 C-0.38226016 11.23547967 -0.09525387 8.9538637 -0.0625 5.875 C-0.05347656 4.77929688 -0.04445312 3.68359375 -0.03515625 2.5546875 C-0.02355469 1.71164063 -0.01195312 0.86859375 0 0 Z ",
    fill: "#EFE1E1",
    transform: "translate(255,180)"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C2 3.31 2 5.62 2 8 C0.02 8.66 -1.96 9.32 -4 10 C-2.8905928 6.51329166 -1.73662334 3.22515763 0 0 Z ",
    fill: "#F0E1E1",
    transform: "translate(313,292)"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.60379341 -0.05416188 3.20811406 -0.09286638 4.8125 -0.125 C5.70582031 -0.14820313 6.59914062 -0.17140625 7.51953125 -0.1953125 C10 0 10 0 13 2 C7.06 2.495 7.06 2.495 1 3 C0.67 2.01 0.34 1.02 0 0 Z ",
    fill: "#EFDDDD",
    transform: "translate(180,255)"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 2.31 0 4.62 0 7 C-1.98 7.33 -3.96 7.66 -6 8 C-5.690625 7.401875 -5.38125 6.80375 -5.0625 6.1875 C-3.89790296 3.91043228 -3.89790296 3.91043228 -3 1 C-1 0 -1 0 0 0 Z ",
    fill: "#FBF5F5",
    transform: "translate(300,323)"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.83022097 3.99560608 1.76210446 7.42737323 1 12 C0.34 12 -0.32 12 -1 12 C-1.02698189 10.37509046 -1.04638757 8.75005367 -1.0625 7.125 C-1.07410156 6.22007812 -1.08570313 5.31515625 -1.09765625 4.3828125 C-1 2 -1 2 0 0 Z ",
    fill: "#F0E6E6",
    transform: "translate(256,153)"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.97 0 5.94 0 9 0 C6.14693203 2.32472205 3.45925163 3.7508258 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#EFEEEE",
    transform: "translate(90,15)"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C2 2.65 2 4.3 2 6 C0.35 6.33 -1.3 6.66 -3 7 C-3 6.01 -3 5.02 -3 4 C-2.34 4 -1.68 4 -1 4 C-0.67 2.68 -0.34 1.36 0 0 Z M-5 7 C-4.01 7.495 -4.01 7.495 -3 8 C-3.99 8.495 -3.99 8.495 -5 9 C-5 8.34 -5 7.68 -5 7 Z ",
    fill: "#F2E6E6",
    transform: "translate(223,444)"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.99 1.32 1.98 2 3 C-0.97 5.475 -0.97 5.475 -4 8 C-3.67 6.68 -3.34 5.36 -3 4 C-2.34 4 -1.68 4 -1 4 C-0.67 2.68 -0.34 1.36 0 0 Z M-6 8 C-5.01 8.495 -5.01 8.495 -4 9 C-4.99 9.495 -4.99 9.495 -6 10 C-6 9.34 -6 8.68 -6 8 Z ",
    fill: "#F3E5E6",
    transform: "translate(198,479)"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 1.65 0 3.3 0 5 C-1.32 5 -2.64 5 -4 5 C-4.33 5.66 -4.66 6.32 -5 7 C-4.53479806 4.30182875 -3.4249099 0 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(255,400)"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.94875 0.04125 1.8975 0.0825 2.875 0.125 C2.875 1.115 2.875 2.105 2.875 3.125 C0.235 2.795 -2.405 2.465 -5.125 2.125 C-3.125 0.125 -3.125 0.125 0 0 Z ",
    fill: "#F0EAEA",
    transform: "translate(252.125,14.875)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPin3);
export default __webpack_public_path__ + "static/media/location-pin-3.21082011b560211be7e4e5014e8a7ae5.svg";
export { ForwardRef as ReactComponent };